module.exports = __webpack_public_path__ + "img/employers-anytime.0de5a15c.png";